<template>
  <body class="hold-transition login-page">
  <div class="login-box" style="margin: 11% auto;">
    <div class="login-logo">
      <img src="/static/img/crp-images/Logo_RCP_Smart_App.png" class="logo-login-signup">
    </div>
    <!-- /.login-logo -->
    <div class="box login-bbox">
      <div class="box-body login-card-body pd-20">
        <p class="login-box-msg login-txt">Enter a new password</p>
        <md-field :class="getValidationClass('new_password')">
          <label>New password</label>
          <md-input type="password" name="new_password" id="new_password" v-model="form.new_password"/>
          <!-- <span class="md-error" v-if="!$v.form.new_password.required">The new password is required</span> -->
          <!-- <span class="md-error" v-if="$v.form.new_password.required && this.backendValidationForm.new_password.isError">{{this.backendValidationForm.new_password.errorMsg}}</span> -->
           <span  :style="$v.form.new_password.required && this.backendValidationform.new_password.isError ? 'color:red;' : 'color: gray;'" class="pw-info md-error" >Password must contain at least:
                    6 Characters, 1 Uppercase letter, 1 Lowercase letter, 1 Special Character and 1 number</span>
        </md-field>
        <br>
        <md-field :class="getValidationClass('confirm_password')">
          <label>Confirm password</label>
          <md-input type="password" name="confirm_password" id="confirm_password" v-model="form.confirm_password"/>
          <span class="md-error" v-if="!$v.form.confirm_password.required">The confirm password is required</span>
          <span class="md-error" v-if="$v.form.confirm_password.required && this.backendValidationForm.confirm_password.isError">{{this.backendValidationForm.confirm_password.errorMsg}}</span>
        </md-field>
        <br>
        <md-card-actions>
          <md-button class="rgbtnn md-raised md-accent login-btn btn-block" @click="validateSubmission">Reset</md-button>
        </md-card-actions>
      </div>
    </div>
  </div>
  </body>
</template>
</script>
<script>
import api from '../../../api'
import $ from 'jquery'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'

var SyncLoader = require('vue-spinner/src/SyncLoader')

export default {
  name: 'UserLoginView',
  components: {
    'SyncLoader': SyncLoader
  },
  mixins: [validationMixin],
  data: () => ({
    form: {
      reset_code: null,
      new_password: null,
      confirm_password: null
    },
    backendValidationForm: {
      reset_code: {
        isError: false,
        errorMsg: ''
      },
      new_password: {
        isError: false,
        errorMsg: ''
      },
      confirm_password: {
        isError: false,
        errorMsg: ''
      }
    }
  }),
  validations: {
    form: {
      new_password: {
        required
      },
      confirm_password: {
        required
      }
    }
  },
  methods: {
    clearNewForm() {
      this.$v.$reset()
      this.form.reset_code = ''
      this.form.new_password = ''
      this.form.confirm_password = ''
    },
    validateSubmission() {
      this.$v.form.$touch()
      this.form.reset_code = this.getUrlVars()['reset_code']
      if (!this.$v.form.$invalid) {
        this.addNewRecord(this.$v.form.$model)
      }
    },
    getUrlVars() {
      var vars = {}
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
        vars[key] = value
      })
      return vars
    },
    addNewRecord(data) {
      var ref = this
      api.request('post', '/customer/updatepassword', data)
        .then(response => {
          if (response.status === 200) {
            if (response.data.error) {
              $.each(response.data.error, function(key, valueObj) {
                if (ref.backendValidationForm.hasOwnProperty(key.toString())) {
                  ref.backendValidationForm[key.toString()].isError = true
                  ref.backendValidationForm[key.toString()].errorMsg = valueObj[0]
                  $('#' + key.toString()).parent().addClass('md-invalid')
                  $('.' + key.toString()).addClass('md-invalid')
                }
              })
            } else if (response.data.result.status === 'success') {
              // eslint-disable-next-line no-undef
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.result.status.message || 'Password reset successfull',
                showConfirmButton: false,
                timer: 2000
              })
              ref.$router.push('/user/login')
              this.clearNewForm()
            } else if (response.data.result.status === 'error') {
              this.newModalLoading = false
              // this.newModal = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: response.data.result.message})
            }
          } else {
            this.newModalLoading = false
            // this.newModal = false
            // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: 'Something wrong'})
          }
          // console.log(response)
          // if (response.hasOwnProperty('result') && response.result.hasOwnProperty('status') && response.status.status === 'success') {
          //   this.newModalLoading = false
          //   // this.form = response.data.result
          //   this.newModal = false
          //   // eslint-disable-next-line no-undef
          //   toast.fire({icon: 'success', title: 'Record successfully saved'})
          //   // eslint-disable-next-line no-undef
          //   Swal.fire({
          //     position: 'center',
          //     icon: 'success',
          //     title: response.result.status.message || 'You have registered successfully',
          //     showConfirmButton: false,
          //     timer: 2000
          //   })
          //   this.clearNewForm()
          // } else if (response.hasOwnProperty('error') && response.error.hasOwnProperty('error') && response.error.error === 'error') {
          //   // form errorsback end
          // } else {
          //   this.newModalLoading = false
          //   // eslint-disable-next-line no-undef
          //   toast.fire({icon: 'error', title: 'Something wrong'})
          // }
        }).catch(error => {
          this.newModalLoading = false
          this.$store.commit('TOGGLE_LOADING')
        // eslint-disable-next-line no-undef
          toast.fire({icon: 'error', title: error})
          this.response = 'Server appears to be offline'
          this.toggleLoading()
        })
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
  }
}
</script>
<style>
  /*.logo-login-signup {*/
  /*  max-width: 50% !important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// UserPassResetView.vue?788f3d91